var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphRespiratory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 57,
    viewBox: "0 0 263 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 55.1472C0 55.1472 30.239 35.4934 55.0277 33.7276C74.6928 32.3268 84.6824 42.3268 104.391 41.2245C141.082 39.1723 140.845 -2.17943 177.222 1.59824C204.61 4.44251 201.374 32.2861 229.012 33.7276C242.614 34.4371 263 28.3727 263 28.3727",
    stroke: "#00C6A9",
    strokeWidth: 1.91724,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphRespiratory);
export default __webpack_public_path__ + "static/media/graphRespiratory.e7ddfd1ab110d67d09dd975f25d1499d.svg";
export { ForwardRef as ReactComponent };